export const pageBasic = {
    // ロード完了したとき
    loadDone: function (results, paramList) {
        $(".js-ajax").html(results["template"]);
        $(".js-content").hide().fadeIn(300);

        // 保存ボタンが押されたときの挙動。
        $(".js-submit").unbind();
        $(".js-submit").click(function () {
            form.disableButtons(this);

            $(".nursery__side-menu-content").data("editing", "false");
            window.removeEventListener("beforeunload", nursery.saveAlert);
            const url = $("#basicForm").attr("action");
            form.post(url, "#basicForm", "更新が完了しました", () => {
                pageBasic.postDone();
                form.activateButtons(this);
            });
        });

        // 都道府県情報の変更のドロップダウン構成
        $("[name=prefectureCode]").unbind();
        $("[name=prefectureCode]").change(function () {
            postCode.changePrefectureDropDownList();
        });

        // 初期化
        postCode.changePrefectureDropDownList(false);

        // 郵便番号検索ボタン
        $(".js-post-code").unbind();
        $(".js-post-code").click(function () {
            const postCodeValue = $("#postCode").val();
            postCode.postCodeToAddress(postCodeValue);
        });

        // フォームに変更があった際、離脱時にアラートを表示
        $("form").change(function () {
            $(".nursery__side-menu-content").data("editing", "true");
            window.addEventListener("beforeunload", nursery.saveAlert);
        });

        //テキストエリアのPlaceHolderは改行の不具合対策のためJSで追加
        const accessContentText = "例\n○○ICより車で10分\n▲▲の入っているビルの4Fです";
        $("[name=accessContent]").attr("placeholder", accessContentText);
    },
    // POST完了
    postDone: function (results) {
        $("#js-nav-pagetop").trigger("click");
    }
};
